import React from 'react';
import { useDatabaseContext } from '../contexts/DatabaseContext';
import { useFilteredArticles } from '../hooks/useFilteredArticles';
import ArticleSelector from '../components/ArticleSelector';
import CyclesDeVieTable from '../components/CyclesDeVieTable';
import { Article, FilterRule } from '../types/api.types';

const CyclesDeVie: React.FC = () => {
  const { activeDatabase } = useDatabaseContext();
  const [filters, setFilters] = React.useState<FilterRule[]>([]);
  const { data, isLoading, error } = useFilteredArticles({
    databaseId: activeDatabase?.id || null,
    filters,
  });

  const [articles, setArticles] = React.useState<Article[]>([]);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-gray-900 mb-4">Cycles de vie</h1>
      <ArticleSelector
        onApplyFilters={setFilters}
        onSelectionChange={() => {}}
        onArticlesChange={setArticles}
      />
      {isLoading && <div>Chargement...</div>}
      {error && <div className="text-red-500">{error.message}</div>}
      {data && <CyclesDeVieTable articles={articles} />}
    </div>
  );
};

export default CyclesDeVie;
